// extracted by mini-css-extract-plugin
export default {"root":"EntityItem_root__s9s46","primary":"EntityItem_primary__5h-sr","active":"EntityItem_active__6s+ko","secondary":"EntityItem_secondary__jq7r4"};